import HowItWorksSteps from "../HowItWorksSteps";
import SectionViewAllLink from "./SectionViewAllLink";

const HomeHowItWorksSection = ({ Reveal }) => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="relative py-28 md:py-36 scroll-mt-28"
    style={{ background: "var(--bg)" }}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-4">
          <div className="text-center md:text-left max-w-2xl md:max-w-none mx-auto md:mx-0">
            <span
              className="inline-block text-[11px] uppercase tracking-[0.25em] font-semibold mb-4"
              style={{ color: "var(--brand)" }}
            >
              How it works
            </span>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]"
              style={{ color: "var(--text)" }}
            >
              Three quiet steps to a{" "}
              <span className="italic" style={{ color: "var(--brand)" }}>
                richer reading life
              </span>
            </h2>
          </div>
          <SectionViewAllLink
            to="/how-it-works"
            label="Full walkthrough"
            testId="how-it-works-view-all-btn"
            className="hidden md:inline-flex shrink-0 mx-auto md:mx-0"
          />
        </div>
      </Reveal>

      <HowItWorksSteps className="mt-20" />

      <Reveal className="mt-10 flex justify-center md:hidden">
        <SectionViewAllLink
          to="/how-it-works"
          label="Full walkthrough"
          testId="how-it-works-view-all-btn-mobile"
        />
      </Reveal>
    </div>
  </section>
);

export default HomeHowItWorksSection;
